import { useEffect, useState, useRef } from "react";
import { useMutation } from "@apollo/client";
import { useAuthState } from "../contexts/auth/auth.provider";
import { CREATE_FAV, DELETE_FAV } from "../graphql/mutations/fav-listing";
import {
  useFavListingsDispatch,
  useFavListingsState,
} from "../contexts/fav-listings/favListings.provider";
import actions from "../contexts/fav-listings/favListings.actions";
import { addFavListingID, removeFavListingID } from "../lib/helpers";
import logger from "../../console";

const { addFavListing, removeFavListing } = actions;

export default function useToggleFav(listingID) {
  const dispatchFavListing = useFavListingsDispatch();
  const token = useAuthState("token");
  const favListings = useFavListingsState();
  const [isFaved, setIsFaved] = useState(favListings[listingID]);
  const prevFavStateRef = useRef(favListings[listingID]);

  function getFavMutation() {
    if (isFaved) {
      return DELETE_FAV;
    }
    return CREATE_FAV;
  }
  const [toggleFavMutation, { data }] = useMutation(getFavMutation(), {
    context: { token },
    fetchPolicy: "no-cache",
    onError: (err) => {
      logger.error(err.message);
    },
  });

  useEffect(() => {
    const currentFavState = favListings[listingID];
    if (currentFavState !== prevFavStateRef.current) {
      prevFavStateRef.current = currentFavState;
      setIsFaved(currentFavState);
    }
  }, [listingID]);

  useEffect(() => {
    if (data) {
      const { User } = data;
      if (User.createFav) {
        setIsFaved(true);
        addFavListingID(listingID);
        dispatchFavListing(addFavListing(listingID));
      }

      if (User.deleteFav) {
        setIsFaved(false);
        removeFavListingID(listingID);
        dispatchFavListing(removeFavListing(listingID));
      }
    }
  }, [data]);

  return { isFaved, toggleFavMutation };
}
